import React from "react";

const SessionExpireModal = ({ onConfirm }) => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.6)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "25px",
          borderRadius: "10px",
          width: "400px",
          textAlign: "center",
        }}
      >
        <h3 style={{ marginBottom: "10px" }}>Session Expired</h3>

        <p>You were inactive for a long time.</p>
        <p>Please login again to continue.</p>

        <button
          onClick={onConfirm}
          style={{
            marginTop: "15px",
            padding: "10px 20px",
            background: "#E23A2E",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          Login Again
        </button>
      </div>
    </div>
  );
};

export default SessionExpireModal;
